export default {
  'Add Employee': '添加员工',
  'Edit Employee': '编辑员工信息',
  'Employee List': '员工列表',
  'Basic info': '基本信息',
  Position: '职位',
  Save: '保存',
  Mobile: '手机',
  'Email or Mobile': '邮箱或手机号',
  'Please upload your profile picture': '请上传头像',
  'Please enter your name': '请输入姓名',
  'Please enter your mobile': '请输入手机号',
  'Mobile already exist': '手机号已存在',
  'Mobile is not correct': '请填写正确手机号',
  'Please enter your email': '请输入邮箱',
  'Please enter your email correctly': '请输入正确的邮箱',
  'Email already exist': '账号已存在，请返回登录。如忘记密码请点击"忘记密码"重设。',
  Confirm: '提示',
  'Are you sure detele this staff?': '您的操作将会删除当前选中的员工，是否继续操作？',
  'Are you sure detele this item?': '您的操作将会删除当前选中的展品，是否继续操作？',
  'Are you sure detele this item1?': '您的操作将会删除当前选中的全部展品，是否继续操作？',
  'Please enter your mobile or email': '请填写手机号或邮箱',
  'Mobile number or Email are not correct': '请填写正确的手机号或邮箱',
  'Please enter your ID Card correctly': '请输入正确的身份证号',
  'Male': '男',
  'Female': '女',
  'Update successfully': '更新个人信息成功'
}
